"use strict";

var _regenerator = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/regenerator.js").default;
var _asyncToGenerator = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _createForOfIteratorHelper = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribe = exports.subscribe = exports.connectStreaming = exports.streamedDataStore = exports.DISABLE_STREAMING = void 0;
var utils_1 = require("./utils");
var atom_types_1 = require("@atom-finance/atom-types");
var riverWebServerURL = (_a = process.env.REACT_APP_RIVER_URL) !== null && _a !== void 0 ? _a : 'wss://staging-river-server.atom.finance';
exports.DISABLE_STREAMING = !!process.env.REACT_APP_DISABLE_STREAMING || !!localStorage.getItem("disableStreaming");
exports.streamedDataStore = new Map();
var socket;
var SocketState;
(function (SocketState) {
  SocketState[SocketState["CONNECTING"] = 0] = "CONNECTING";
  SocketState[SocketState["OPEN"] = 1] = "OPEN";
  SocketState[SocketState["CLOSING"] = 2] = "CLOSING";
  SocketState[SocketState["CLOSED"] = 3] = "CLOSED";
})(SocketState || (SocketState = {}));
var connectStreaming = function connectStreaming() {
  var nthTry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  if (exports.DISABLE_STREAMING) {
    return;
  }
  console.debug("River: Connecting to river. (Try # ".concat(nthTry, ")"));
  socket = new WebSocket(riverWebServerURL);
  var hasOpened = false;
  var hasReceivedPong = false;
  socket.onmessage = function (msg) {
    try {
      var data = JSON.parse(msg.data);
      if (data.messageType === atom_types_1.RiverServerMessageType.Pong) {
        hasReceivedPong = true;
        return;
      }
      if (data.messageType === atom_types_1.RiverServerMessageType.Trades) {
        var _iterator = _createForOfIteratorHelper(data.trades),
          _step;
        try {
          var _loop = function _loop() {
            var element = _step.value;
            var savedSymbol = exports.streamedDataStore.get(element.symbol);
            if (savedSymbol) {
              savedSymbol.updateComponentFunctions.forEach(function (x) {
                return x(element);
              });
              savedSymbol.streamedData = element;
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    } catch (e) {
      console.error(e);
    }
  };
  socket.onopen = function () {
    hasOpened = true;
    try {
      var tickers = Array.from(exports.streamedDataStore.keys());
      if (!tickers.length) {
        return;
      }
      console.debug("River: sending subscriptions on socket open. Number of subscriptions: ", tickers.length);
      socket === null || socket === void 0 ? void 0 : socket.send(JSON.stringify({
        messageType: atom_types_1.RiverClientMessageType.Sub,
        tickers: tickers
      }));
    } catch (e) {
      console.error(e);
    }
  };
  socket.onerror = function (error) {
    console.error("River: Error from Websocket", error);
  };
  var _checkForPong = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (socket) {
              _context.n = 1;
              break;
            }
            console.debug("River: Undefined socket in checkPong!");
            return _context.a(2);
          case 1:
            _t = socket.readyState;
            _context.n = _t === SocketState.CLOSED ? 2 : _t === SocketState.CLOSING ? 2 : _t === SocketState.CONNECTING ? 3 : _t === SocketState.OPEN ? 5 : 8;
            break;
          case 2:
            console.debug("River: Connection closed. Starting a new connection.");
            (0, exports.connectStreaming)(hasOpened ? 1 : nthTry + 1);
            return _context.a(2);
          case 3:
            console.debug('River: Connecting, waiting to check for pong.');
            _context.n = 4;
            return (0, utils_1.sleep)(Math.min(3000 * nthTry, 10000));
          case 4:
            _checkForPong();
            return _context.a(2);
          case 5:
            hasReceivedPong = false;
            socket.send(JSON.stringify({
              messageType: 'Ping'
            }));
            _context.n = 6;
            return (0, utils_1.sleep)(3000);
          case 6:
            if (!hasReceivedPong) {
              _context.n = 7;
              break;
            }
            _checkForPong();
            return _context.a(2);
          case 7:
            console.debug("River: Ping failed. Starting a new connection.");
            socket.close();
            (0, exports.connectStreaming)();
            return _context.a(2);
          case 8:
            console.debug("River: Unhandled socket ready state. (".concat(socket.readyState, ")"));
            _checkForPong();
          case 9:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function checkForPong() {
      return _ref.apply(this, arguments);
    };
  }();
  _checkForPong();
  return socket;
};
exports.connectStreaming = connectStreaming;
var sendIfOpen = function sendIfOpen(msg) {
  if (!socket) {
    return;
  }
  // Make sure tickers not empty
  if (msg.messageType !== atom_types_1.RiverClientMessageType.Ping && !msg.tickers.length) {
    console.debug("River: ignoring message because empty tickers array.");
    return;
  }
  // Make sure socket open
  if (socket.readyState !== SocketState.OPEN) {
    console.debug("River: ignoring message because socket is not currently open");
    return;
  }
  socket.send(JSON.stringify(msg));
};
var SUB_BATCH_TIME = 50; // 50ms sub batches
var UNSUB_BATCH_TIME = 1000; // 1s unsub batches (don't need to be fast to unsub)
var subBatch = new Set(); // batch of tickers in queue to subscribe
var unSubBatch = new Set(); // batch of tickers in queue to unsubscribe
var subscribe = function subscribe(symbol, action) {
  // if we have an unsub opp in queue for a symbol we should remove it from the unSubBatch since we want to subscribe
  if (unSubBatch.has(symbol)) unSubBatch.delete(symbol);
  var savedSymbol = exports.streamedDataStore.get(symbol);
  if (savedSymbol) {
    savedSymbol.updateComponentFunctions.push(action);
    return;
  }
  if (!subBatch.size) {
    setTimeout(function () {
      if (!subBatch.size) return;
      var tickers = Array.from(subBatch);
      subBatch.clear();
      sendIfOpen({
        messageType: atom_types_1.RiverClientMessageType.Sub,
        tickers: tickers
      });
    }, SUB_BATCH_TIME);
  }
  subBatch.add(symbol);
  console.debug("River: adding to streamed data store", symbol);
  exports.streamedDataStore.set(symbol, {
    streamedData: null,
    updateComponentFunctions: [action]
  });
};
exports.subscribe = subscribe;
var unsubscribe = function unsubscribe(symbol, action) {
  // if we have a sub opp in queue for a symbol we should remove it from the subBatch since we want to unsubscribe
  if (subBatch.has(symbol)) subBatch.delete(symbol);
  var savedSymbol = exports.streamedDataStore.get(symbol);
  if (!savedSymbol) {
    return;
  }
  savedSymbol.updateComponentFunctions = savedSymbol.updateComponentFunctions.filter(function (x) {
    return x !== action;
  });
  if (!unSubBatch.size) {
    setTimeout(function () {
      var tickers = Array.from(unSubBatch);
      // Only unsub tickers if not contain update functions
      for (var _i = 0, _tickers = tickers; _i < _tickers.length; _i++) {
        var ticker = _tickers[_i];
        var savedTicker = exports.streamedDataStore.get(ticker);
        if (!(savedTicker === null || savedTicker === void 0 ? void 0 : savedTicker.updateComponentFunctions.length)) {
          exports.streamedDataStore.delete(ticker);
        } else {
          // Do not unsub, another component is still using this streaming data.
          console.debug("River: Symbol still in use by other component", ticker);
          unSubBatch.delete(ticker);
        }
      }
      if (!unSubBatch.size) return;
      var unSubTickers = Array.from(unSubBatch);
      console.debug("River: removing from streamed data store", unSubTickers);
      unSubBatch.clear();
      sendIfOpen({
        messageType: atom_types_1.RiverClientMessageType.Unsub,
        tickers: unSubTickers
      });
    }, UNSUB_BATCH_TIME);
  }
  unSubBatch.add(symbol);
};
exports.unsubscribe = unsubscribe;